import HttpService from '../../infra/http/AxiosConfig'
import CancelablePromise from '../../functions/CancelablePromise';
import {formatToNumber} from "../NumberService";

const formToApiRequest = value => {
  const { parameter } = value
  return {
    idRevenda: value.resaleId,
    id: value.id,
    cpf: value.cpf,
    email: value.email,
    //foto: value.photo ? value.photo.split(',')[1] : "",
    nome: value.name,
    senha: value.password,
    telefone: value.phone,
    status: value.status
  }
}

const apiRequestToForm = driver => {
  return ({
    resaleId: driver.idRevenda,
    resaleName: driver.nomeFantasia,
    id: driver.id,
    cpf: driver.cpf,
    email: driver.email,
    // photo: driver.foto ? driver.foto.nome : '',
    // photoUrl: driver.foto ? driver.foto.url : '',
    name: driver.nome,
    phone: driver.telefone,
    password: ""
  })
}

const resource = 'motoristas'

export const post = value =>
  HttpService.AxiosClient.post(resource, value);

export const update = value =>
  HttpService.AxiosClient.put(resource, formToApiRequest(value));

export const updatePassword = value =>
  HttpService.AxiosClient.put(`${resource}/atualizarSenha`, formToApiRequest(value));

export const updateStatus = value =>
  HttpService.AxiosClient.put(`${resource}/atualizarStatus`, formToApiRequest(value));

export const updateAllStatus = (values) =>
  HttpService.AxiosClient.put(`${resource}/atualizarTodosStatus`, { idOrganizacao: values.idOrganizacao, idRevenda: values.idRevenda, status: values.status });

export const get = (page, pageSize, filter, resale) =>
  CancelablePromise(HttpService.AxiosClient.get(`${resource}\\${page}\\${pageSize}`, { params: { filtro: filter, revenda: resale } } ))

// export const getStatus = (page, pageSize, filter, resale) =>
//   CancelablePromise(HttpService.AxiosClient.get(`${resource}\\status\\${page}\\${pageSize}?filtro=${filter}`))

export const find = id =>
  new Promise(async (resolve, reject) => {
    try {
      const result = await HttpService.AxiosClient.get(`${resource}\\${id}`)
      const driver = apiRequestToForm(result);
      driver.id = id;
      resolve(driver)
    } catch (error) {
      reject(error)
    }
  })

export const remove = driverId =>
  HttpService.AxiosClient.delete(`${resource}\\${driverId}`)


